import request from '@/utils/requestMobile'

export function login(data) {
  return request({
    url: '/mobile/user/login',
    method: 'post',
    data
  })
}

export function formLogin(data) {
  return request({
    url: '/mobile/from/user/login',
    method: 'post',
    data
  })
}

export function logout(data) {
  return request({
    url: '/mobile/user/exit',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/mobile/user/info',
    method: 'post',
    data
  })
}

export function userRegister(data) {
  return request({
    url: '/mobile/user/register',
    method: 'post',
    data
  })
}

export function sendSmsCode(data) {
  return request({
    url: '/mobile/user/sms/send/code',
    method: 'post',
    data
  })
}

export function findSmsCode(data) {
  return request({
    url: '/mobile/user/sms/find/code',
    method: 'post',
    data
  })
}

export function userFindPassword(data) {
  return request({
    url: '/mobile/user/password/find/save',
    method: 'post',
    data
  })
}

export function saveOrderData(data) {
  return request({
    url: '/mobile/order/save',
    method: 'post',
    data
  })
}

export function updatePassword(data) {
  return request({
    url: '/mobile/update/password',
    method: 'post',
    data
  })
}

export function saveUserSetting(data) {
  return request({
    url: '/mobile/user/setting/save',
    method: 'post',
    data
  })
}

export function getUserSetting(data) {
  return request({
    url: '/mobile/user/setting/data',
    method: 'post',
    data
  })
}

export function getLeaveList(data) {
  return request({
    url: '/mobile/leave/list',
    method: 'post',
    data
  })
}

export function getLeaveInit(data) {
  return request({
    url: '/mobile/leave/apply/init',
    method: 'post',
    data
  })
}

export function saveLeave(data) {
  return request({
    url: '/mobile/leave/save',
    method: 'post',
    data
  })
}

export function deleteLeave(data) {
  return request({
    url: '/mobile/leave/delete',
    method: 'post',
    data
  })
}

export function getUserClassTimesList(data) {
  return request({
    url: '/mobile/class/time/list',
    method: 'post',
    data
  })
}

export function getOrderList(data) {
  return request({
    url: '/mobile/order/list',
    method: 'post',
    data
  })
}

export function getOrderDetail(data) {
  return request({
    url: '/mobile/order/detail',
    method: 'post',
    data
  })
}

export function getOrderPayInfo(data) {
  return request({
    url: '/mobile/order/pay/info',
    method: 'post',
    data
  })
}

export function deleteOrder(data) {
  return request({
    url: '/mobile/delete/order',
    method: 'post',
    data
  })
}

export function getSingOrderRefundInit(data) {
  return request({
    url: '/mobile/order/refund/init',
    method: 'post',
    data
  })
}

export function saveSingOrderRefund(data) {
  return request({
    url: '/mobile/order/refund/save',
    method: 'post',
    data
  })
}

export function getGradeTotal(data) {
  return request({
    url: '/mobile/grade/total/list',
    method: 'post',
    data
  })
}

export function getClassCallList(data) {
  return request({
    url: '/mobile/grade/call/list',
    method: 'post',
    data
  })
}

export function getWxConfig(data) {
  return request({
    url: '/mobile/get/wxconfig',
    method: 'post',
    data
  })
}

export function getSchoolWxConfig(data) {
  return request({
    url: '/mobile/get/school/wxconfig',
    method: 'post',
    data
  })
}

export function saveVideoOrderData(data) {
  return request({
    url: '/mobile/video/order/save',
    method: 'post',
    data
  })
}

export function getMonthClassTimes(data) {
  return request({
    url: '/mobile/user/month/class/times',
    method: 'post',
    data
  })
}

export function getVideoOrderList(data) {
  return request({
    url: '/mobile/user/video/orders/list',
    method: 'post',
    data
  })
}

export function deleteVideoOrder(data) {
  return request({
    url: '/mobile/user/video/orders/delete',
    method: 'post',
    data
  })
}

export function getSchoolList(data) {
  return request({
    url: '/mobile/school/list',
    method: 'post',
    data
  })
}

export function getUserCouponTotal(data) {
  return request({
    url: '/mobile/user/coupon/total',
    method: 'post',
    data
  })
}

export function getUserCouponList(data) {
  return request({
    url: '/mobile/user/coupon/type/list',
    method: 'post',
    data
  })
}

export function deleteUserCoupon(data) {
  return request({
    url: '/mobile/user/coupon/delete',
    method: 'post',
    data
  })
}

export function getRegisterSchoolList(data) {
  return request({
    url: '/mobile/school/register/list',
    method: 'post',
    data
  })
}

export function addNewStudent(data) {
  return request({
    url: '/mobile/register/new/student',
    method: 'post',
    data
  })
}

export function changeStudent(data) {
  return request({
    url: '/mobile/change/student',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/mobile/user.js